import type { ISegment } from "../../helpers";

import { useSegmentFilterCascaded } from "../../helpers";
import { BranchesDropdown, BrandsDropdown, ChannelsDropdown, MarketersDropdown, StatesDropdown } from "./";
import { useSyncedSegment } from "./useSyncedSegment";

export function SegmentFilters(props: Props) {
	const { value, onChange, onUnfocused } = props;
	const [segmentFilters, segmentChanged] = useSyncedSegment(value, onChange, SEGMENT_KEYS, emptySegmentFilters);
	const availableSegments = useSegmentFilterCascaded(segmentFilters);

	//TODO: handle optional "All X" vs none selected just means all
	//TODO: handle auto-select if single for multi
	//Maybe if auto-selected (and only one option in master list), we just display nice text: "Brand: Spectrum"
	//TODO: setup cascading and active only etc
	return (
		<>
			<BrandsDropdown
				options={availableSegments.brands}
				loaded={availableSegments.brandsLoaded}
				value={segmentFilters.brandIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<ChannelsDropdown
				options={availableSegments.channels}
				loaded={availableSegments.channelsLoaded}
				value={segmentFilters.channelIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<MarketersDropdown
				options={availableSegments.marketers}
				loaded={availableSegments.marketersLoaded}
				value={segmentFilters.marketerIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<StatesDropdown
				options={availableSegments.states}
				loaded={availableSegments.statesLoaded}
				value={segmentFilters.stateIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<BranchesDropdown
				options={availableSegments.branches}
				loaded={availableSegments.branchesLoaded}
				value={segmentFilters.branchIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
		</>
	);
}

export const emptySegmentFilters: ISegment = {
	branchIds: [],
	brandIds: [],
	channelIds: [],
	marketerIds: [],
	stateIds: [],
};

const SEGMENT_KEYS = [
	"brandId",
	"channelId",
	"marketerId",
	"stateId",
	"branchId",
	"brandIds",
	"channelIds",
	"marketerIds",
	"stateIds",
	"branchIds",
	"showInactiveOffices",
	"assignedUserIds",
] as const satisfies readonly (keyof ISegment)[];

interface Props {
	onChange: (filters: ISegment) => void;
	value?: ISegment;
	onUnfocused?: (event?: React.FocusEvent<any>) => void;
}
